import { useLocaleContext } from '../../i18n';
import BaseSlider from './BaseSlider';

interface Props {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  zoneColor?: string;
}

export default function SafetyMarginSlider({ value, onChange, disabled, zoneColor }: Props) {
  const { locale } = useLocaleContext();

  return (
    <BaseSlider
      label={locale.planner.safetyMargin}
      value={value}
      onChange={onChange}
      min={0}
      max={50}
      step={1}
      unit="g"
      disabled={disabled}
      zoneColor={zoneColor}
      secondary={locale.planner.safetyMarginDescriptions.find(
        (desc) => value >= desc.min && value <= desc.max
      )?.text}
    />
  );
}
